module.exports = __webpack_public_path__ + "img/ring_skip_skip_1_0@2x.ad71f761.png";